/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Section_5_IntroInputs */

const en_privacy_section_5_intro = /** @type {(inputs: Privacy_Section_5_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`We use the following third-party services that may process your data:`)
};

const lv_privacy_section_5_intro = /** @type {(inputs: Privacy_Section_5_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mēs izmantojam šādus trešo pušu pakalpojumus, kas var apstrādāt Jūsu datus:`)
};

/**
* | output |
* | --- |
* | "We use the following third-party services that may process your data:" |
*
* @param {Privacy_Section_5_IntroInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const privacy_section_5_intro = /** @type {((inputs?: Privacy_Section_5_IntroInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Section_5_IntroInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_privacy_section_5_intro(inputs)
	return en_privacy_section_5_intro(inputs)
});